import { SelectDesignerLabels } from 'projects/components/AddDesignerButton';
import { Stat } from 'projects/components/DesignerMeta';
import React from 'react';

export { Stat } from 'projects/components/DesignerMeta';

interface DesignerCardContext {
    highlightNewDesigners?: boolean;
    stats?: Stat[];
    selectDesignerLabels: SelectDesignerLabels;
}

export default React.createContext<DesignerCardContext>({
    highlightNewDesigners: true,
    selectDesignerLabels: {
        selected: __('Added'),
        notSelected: __('Add'),
    },
});
